import { memo } from 'react';
import { theme } from './constants';

const ContactModal = ({ isOpen, onClose, configCode, isCopied, copyToClipboard }) => {
    if (!isOpen) return null;

    return (
        <div
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}
            onClick={onClose}
        >
            <div
                style={{ background: 'white', width: '100%', maxWidth: '500px', borderRadius: '20px', padding: '40px', textAlign: 'center', boxShadow: '0 20px 50px rgba(0,0,0,0.3)' }}
                onClick={e => e.stopPropagation()}
            >
                <div style={{ fontSize: '40px', marginBottom: '20px' }}>✉️</div>
                <h2 style={{ margin: '0 0 15px 0', color: 'rgb(0, 40, 70)', fontWeight: 900 }}>SALES CONTACT</h2>
                <div style={{ fontSize: '20px', fontWeight: 700 }}>Jörgen Skoglund</div>
                <div style={{ fontSize: '16px', margin: '10px 0' }}>Phone: +46 70 550 82 61</div>
                <div style={{ fontSize: '16px', color: theme.primary, fontWeight: 700, marginBottom: '20px' }}>jorgen.skoglund@sspnorth.se</div>

                {/* Configuration Code Box */}
                <div style={{ margin: '30px 0', padding: '20px', background: '#f8fafc', borderRadius: '12px', border: `1.5px solid ${theme.border}`, textAlign: 'left' }}>
                    <div style={{ fontSize: '10px', fontWeight: 900, color: theme.textMuted, letterSpacing: '1px', marginBottom: '8px' }}>
                        CONFIGURATION CODE
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px' }}>
                        <div style={{ fontFamily: 'monospace', fontSize: '13px', fontWeight: 700, color: 'rgb(0, 40, 70)', wordBreak: 'break-all', lineHeight: '1.4' }}>
                            {configCode}
                        </div>
                        <button
                            onClick={copyToClipboard}
                            style={{
                                background: isCopied ? '#22c55e' : 'rgb(0, 40, 70)',
                                color: 'white',
                                border: 'none',
                                padding: '4px 10px',
                                borderRadius: '4px',
                                fontSize: '10px',
                                fontWeight: 700,
                                cursor: 'pointer',
                                transition: 'background 0.2s',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {isCopied ? 'COPIED!' : 'COPY CODE'}
                        </button>
                    </div>
                </div>

                <button
                    onClick={onClose}
                    style={{ width: '100%', padding: '15px', background: 'rgb(0, 40, 70)', color: 'white', border: 'none', borderRadius: '12px', fontWeight: 900, cursor: 'pointer' }}
                >
                    CLOSE
                </button>
            </div>
        </div>
    );
};

export default memo(ContactModal);